// Deterministic avatar color per platform role, shared between the Users admin page and the
// header's account avatar so the same role always reads the same color everywhere.
const ROLE_COLORS = {admin: "#8491F7", manager: "#ED8936", user: "#DB6FA0"};
// fallback colors for any role outside the default three - kept away from green/red, which already
// mean success/error elsewhere in the UI
const EXTRA_ROLE_COLORS = ["#3D86C6", "#2BA3A3", "#D4A017", "#6E5BC4"];

const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  return hash;
};

export const getRoleColor = (role) => {
  if (!role) return "#8A8AA0";
  return ROLE_COLORS[role] || EXTRA_ROLE_COLORS[hashString(role) % EXTRA_ROLE_COLORS.length];
};
